import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        alertMessage: "",
    },
    reducers: {
        setMessage: (state, action) => {
            state.alertMessage = action.payload;
        },
        removeMessage: (state) => {
            state.alertMessage = "";
        },
    },
});

export const { setMessage, removeMessage } = alertSlice.actions;
export default alertSlice.reducer;
